module.exports = __webpack_public_path__ + "img/you.0c87e053.png";